<template>
	<!-- 企业管理-->
	<div class="public_Spacing systemCorporateAccount sales-invoice-page">
		<div class="pulbic_oparetionBlock sales-invoice-filter-panel">
			<div class="sales-invoice-filter-head">
				<div>
					<div class="sales-invoice-filter-title">筛选条件</div>
					<div class="sales-invoice-filter-subtitle">按厂区名称或手机号检索企业发票配置</div>
				</div>
				<div class="sales-invoice-filter-count">共 {{ pagingPage || 0 }} 条</div>
			</div>
			<div class="public_criteriaRange systemCorporateAccount-display sales-invoice-filter-controls">
				<div class="public_oparetionBlock_Menu systemCorporateAccount-wuliao-input sales-invoice-search">
					<span class="public_lbSty">检索：</span>
					<input type="text" v-model="retrievalQuery" placeholder="请输入厂区名称或手机号" />
				</div>
				<el-button class="public_saleWater_chaxun sales-invoice-query-btn" type="primary" v-shiroHiden="solelist" id="查询"
					@click="queryClick">
					<i class="iconfont icon-chaxun"></i>查询
				</el-button>
			</div>
			<!-- <div class="public_operatArea" style="margin-left: 0;">
				<div class="public_operatBtn" style="margin-left: 0;">
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="queryClick">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
					<el-button class="public_saleWater_xinzeng" type="primary" v-shiroHiden="solelist" id="新增"
						@click="newlyAdd">
						<i class="iconfont icon-tianjia1"></i>新增
					</el-button>
				</div>
			</div> -->

		</div>

		<div class="systemCorporateAccount-table pulbic_oparetionBlock pulbic_table_container sales-invoice-table-card">
			<div class="sales-invoice-table-head">
				<div>
					<div class="sales-invoice-table-title">发票设置</div>
					<div class="sales-invoice-table-subtitle">共 {{ pagingPage || 0 }} 条配置，当前页 {{ tableData.length }} 条</div>
				</div>
				<div class="sales-invoice-table-tag">开票比例配置</div>
			</div>
			<el-table :data="tableData" @cell-click="tabClick" :row-class-name="tableRowClassName"
				:cell-class-name="tableCellClassName" style="width: 100%;" max-height="90%" stripe :fit="true"
				:default-sort="{ prop: 'waterNum', order: 'descending' }"
				:header-cell-style="{ color: 'rgba(51,51,51,1)', 'font-weight': 'bold' }" class="public_tableColumn sales-invoice-main-table">
				<el-table-column align="center" width="92" prop="settb100ca00" label="一级企业" show-overflow-tooltip></el-table-column>
				<el-table-column align="center" width="92" prop="settb99ca00" label="二级企业" show-overflow-tooltip></el-table-column>
				<el-table-column align="center" width="96" prop="settb99CA01" label="联系电话" show-overflow-tooltip></el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca01" label="一级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca01">
							{{ scope.row.settb426ca01 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca02" label="二级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca02">
							{{ scope.row.settb426ca02 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca03" label="三级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca03">
							{{ scope.row.settb426ca03 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca04" label="四级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca04">
							{{ scope.row.settb426ca04 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca05" label="五级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca05">
							{{ scope.row.settb426ca05 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca06" label="六级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca06">
							{{ scope.row.settb426ca06 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca07" label="七级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca07">
							{{ scope.row.settb426ca07 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca08" label="八级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca08">
							{{ scope.row.settb426ca08 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca09" label="九级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca09">
							{{ scope.row.settb426ca09 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="46" prop="settb426ca10" label="十级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca10">
							{{ scope.row.settb426ca10 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<el-table-column align="center" width="52" prop="settb426ca11" label="十一级">
					<template slot-scope="scope">
						<span v-if="scope.row.settb426ca11">
							{{ scope.row.settb426ca11 }}%
						</span>
						<span v-else>--</span>
					</template>
				</el-table-column>
				<!-- <el-table-column align="center" prop="SETTB99CA02" label="地址"></el-table-column>
				<el-table-column align="center" prop="ORMTB401CA02" label="账户名称"></el-table-column>
				<el-table-column align="center" prop="ORMTB401CA03" label="账户余额"></el-table-column> -->

				<el-table-column label="操作" align="center" width="132">
					<template slot-scope="scope">
						<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info"
							size="small" @click="DiscountModify(scope.row)" v-shiroHiden="solelist" id="发票设置">
							发票设置
						</el-button>

						<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="info"
							size="small" @click="logDetail(scope.row)" id="修改记录">
							修改记录
						</el-button>


					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limit"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPage"></el-pagination>
			</div>
		</div>


		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="编辑" :visible.sync="updateShow" width="30%" :closeOnClickModal='false' append-to-body custom-class="sales-invoice-dialog">
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseNameModify" v-if="modifyIF == 'BD'" readonly />
							<input type="text" v-model="enterpriseNameModify" placeholder="请输入" v-else />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">企业简称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="enterpriseAbbreviationModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">手机号<span>*</span></div>
						<div class="SCADL-input">
							<!-- v-on:input="phoneNumberModify=phoneNumberModify.replace(/[^\d]/g,'')" -->
							<!-- readonly -->
							<input type="text" maxlength="11" v-model="phoneNumberModify" placeholder="请输入"
								v-if="modifyIF == 'BD'" />
							<input type="text" v-else maxlength="11" v-model="phoneNumberModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户名称<span>*</span></div>
						<div class="SCADL-input">
							<input v-if="modifyIF == 'BD'" readonly type="text" v-model="accountNameModify"
								placeholder="请输入" />
							<input type="text" v-else v-model="accountNameModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">账户余额<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="accountBalanceModify" v-if="modifyIF == 'BD'" readonly
								placeholder="请输入" />
							<input type="text" v-model="accountBalanceModify" v-else placeholder="请输入"
								@keyup="accountBalanceModifyUp" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">地址<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="addressBalanceModify" placeholder="请输入" />
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">市名称<span>*</span></div>
						<div class="SCADL-input">
							<el-select class="SCADL-select" v-model="cityCodeModify" @change="cityNameChangeModify"
								filterable>
								<el-option v-for="item in cityNameList" :key="item.CODETB01CA00"
									:label="item.CODETB01CA01" :value="item.CODETB01CA00">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">派单审核<span>*</span></div>
						<div class="SCADL-input">
							<el-select v-model="uditTypeUpdate">
								<el-option v-for="item in auditList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">公告</div>
						<div class="SCADL-input">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"
								v-model="notice">
							</el-input>
						</div>
					</div> -->

					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="preservationModify">保存</el-button>
						<el-button type="warning" @click="updateShow = false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog invoice-setting-dialog-wrap">
			<el-dialog title="发票设置" :visible.sync="discountShow" width="900px" :closeOnClickModal='false' append-to-body custom-class="sales-invoice-dialog">
					<div class="systemCorporateAccount-dialog invoice-setting-dialog">
						<div class="invoice-setting-banner" style="padding-bottom: 10px;">
							<div>
								<div class="invoice-setting-banner-title">发票开票配置</div>
								<div class="invoice-setting-banner-text">设置企业开票状态、业务公司以及各级客户开票比例</div>
							</div>
						</div>
						
					<div class="systemCorporateAccount-dialog-li invoice-setting-field invoice-setting-field--full">
						<div class="SCADL-text"><span>*</span>企业名称:</div>
						<div class="SCADL-input">
							<input :disabled="disabled" type="text" v-model="settb99ca00" placeholder="请输入" readonly>
						</div>
					</div>
					<div class="invoice-setting-two-col">
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>是否开票:</div>
							<div class="SCADL-input">
								<el-select v-model="settb426ca12" placeholder="请选择">
									<el-option v-for="item in auditList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>业务公司:</div>
							<div class="SCADL-input">
								<el-select v-model="settb426ca13" placeholder="请选择">
									<el-option v-for="item in preferentialType" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
										:value="item.SETTB206CA01">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li invoice-setting-field">
						<div class="SCADL-text"><span>*</span>业务公司:</div>
						<div class="SCADL-input">
							<el-select v-model="settb426ca13" placeholder="请选择">
								<el-option v-for="item in preferentialType" :key="item.SETTB206CA00" :label="item.SETTB206CA01"
									:value="item.SETTB206CA01">
								</el-option>
							</el-select>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">浮动类型<span>*</span></div>
						<div class="SCADL-input">
							<el-radio v-model="floatingType" label="1">上浮</el-radio>
							<el-radio v-model="floatingType" label="2">下调</el-radio>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">浮动金额<span>*</span></div>
						<div class="SCADL-input levelmang-table-KJ public-chech-details">
							<el-input-number style="text-align: center;" :precision="2" :step="1" :min="0" :max="100"
								v-model="floatingAmount"></el-input-number>元
							
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">服务费8.5比例%<span>*</span></div>
						<div class="SCADL-input">
							<el-input type="text" v-model="agreementPriceModify" placeholder="请输入">
								<template slot="append">%</template>
							</el-input>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">服务费8.8比例%<span>*</span></div>
						<div class="SCADL-input">
							<el-input type="text" v-model="agreementedwPriceModify" placeholder="请输入">
								<template slot="append">%</template>
							</el-input>
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">服务费9.1比例%<span>*</span></div>
						<div class="SCADL-input">
							<el-input type="text" v-model="ORMTB401CA23" placeholder="请输入">
								<template slot="append">%</template>
							</el-input>
						</div>
					</div> -->
					<div class="levelBox invoice-setting-level-grid">
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>一级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca01" placeholder="请输入"
									@input="handleInput('settb426ca01', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>二级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca02" placeholder="请输入"
									@input="handleInput('settb426ca02', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>三级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca03" placeholder="请输入"
									@input="handleInput('settb426ca03', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>四级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca04" placeholder="请输入"
									@input="handleInput('settb426ca04', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>五级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca05" placeholder="请输入"
									@input="handleInput('settb426ca05', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>六级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca06" placeholder="请输入"
									@input="handleInput('settb426ca06', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>七级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca07" placeholder="请输入"
									@input="handleInput('settb426ca07', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>八级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca08" placeholder="请输入"
									@input="handleInput('settb426ca08', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>九级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca09" placeholder="请输入"
									@input="handleInput('settb426ca09', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>十级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca10" placeholder="请输入"
									@input="handleInput('settb426ca10', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
						<div class="level-systemCorporateAccount-dialog-li">
							<div class="SCADL-text"><span>*</span>十一级客户:</div>
							<div class="SCADL-input">
								<el-input type="text" v-model="settb426ca11" placeholder="请输入"
									@input="handleInput('settb426ca11', $event)">
									<template slot="append">%</template>
								</el-input>
							</div>
						</div>
					</div>
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">物料类型<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="materialTypeModify" placeholder="请输入">
							<el-select v-model="materialTypeModify">
								<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00" :label="item.SETTB206CA01" :value="item.SETTB206CA00">
								</el-option>
							</el-select>
						</div>
					</div> -->
					<!-- <div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">已开额度<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" v-model="unitMeasurementModify" placeholder="请输入">
						</div>
					</div> -->
					<div class="systemCorporateAccount-dialog-btn invoice-setting-actions">
						<el-button type="warning" @click="discountShow = false">取消</el-button>
						<el-button type="primary" @click="preservationDiscountModify">保存</el-button>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="修改记录" :visible.sync="logShow" width="80%" height="200px" :closeOnClickModal='false' append-to-body custom-class="sales-invoice-dialog">
				<el-table :data="tableDetail" height="550" :row-class-name="tableRowClassName"
					:cell-class-name="tableCellClassName" border
					style="width: 100%; margin-top: 20px;overflow-y: auto;">
					<el-table-column align="center" width="46" prop="settb426ca01" label="一级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca01 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca02" label="二级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca02 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca03" label="三级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca03 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca04" label="四级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca04 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca05" label="五级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca05 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca06" label="六级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca06 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca07" label="七级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca07 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca08" label="八级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca08 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca09" label="九级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca09 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="46" prop="settb426ca10" label="十级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca10 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" width="52" prop="settb426ca11" label="十一级">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca11 }}%
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="settb426ca13" label="业务公司" align="center">
					</el-table-column>
					<el-table-column prop="settb426ca12" label="是否开票" align="center">
						<template slot-scope="scope">
							<span>
								{{ scope.row.settb426ca12==1?'是':'否' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="settb426cb01" label="修改人" align="center">
					</el-table-column>
					<el-table-column prop="settb426cb02" label="修改时间" align="center">
					</el-table-column>

				</el-table>

			</el-dialog>
		</div>

	</div>
</template>

<script>
import * as echarts from 'echarts'

export default {
	data() {
		return {
			logShow: false,

			auditList: [{
				value: 0,
				label: '否'
			}, {
				value: 1,
				label: '是'
			}],
			kaipiaoValue: '',
			clickRowIndex: null, // 当前点击的行索引
			clickCellIndex: null, // 当前点击的列索引
			tabClickLabel: "", // 当前点击的列名
			floatingType: '', //浮动类型-上浮-下浮
			floatingAmount: '', //浮动金额
			disabled: true,
			switchWidth: 30,
			userobj: this.$store.state.uobj, //登陆缓存--用户信息
			retrievalQuery: '',
			tableData: [], //列表table数据--查询
			tableDetail: [], //列表table数据--查询
			page: 1, //默认列表页码
			limit: 10, //每页的条数
			pagingPage: 0, //分页--数据列表共有的条数
			currentPage: 1, //设置当前页默认为1
			// 新增
			insertShow: false,
			insertMLShow: false,
			isIndeterminate: false, // 客户等级全选
			checkAllGrade: false, //客户等级
			checkedCitiesGrade: [], //绑定默认选中客户等级

			ruleForm: {
				grade: [] //客户等级
			},
			editRuleForm: {
				grade: [] //客户等级
			},
			rules: {
				grade: [{
					required: true,
					message: '请选择客户等级',
					trigger: 'change'
				}]
			},
			addEdit: 0,
			objCjMasg: {},
			jgData: {},
			chartHeight: 1000,
			chartWidth: 300,
			insertXGMLShow: false,
			insertJGShow: false,
			enterpriseNameAdd: '', //企业名称
			enterpriseAbbreviationAdd: '', //企业简称
			phoneNumberAdd: '', //手机号
			accountNameAdd: '', //账户名称
			accountBalanceAdd: '', //账户余额
			addressBalanceAdd: '', //地址
			notice: '',
			uditTypeAdd: '1',
			cityNameList: [],
			cityCodeAdd: '',
			cityNameAdd: '',
			djkj: '',
			// 修改
			updateShow: false,
			enterpriseNameModify: '', //企业名称
			enterpriseAbbreviationModify: '', //企业简称
			phoneNumberModify: '', //手机号
			accountNameModify: '', //账户名称
			addressBalanceModify: '', //地址
			accountBalanceModify: '', //账户余额
			uditTypeUpdate: '1',
			ORMTB401ID: '', //帐户ID
			ORMTB401CA00: '', //一级企业ID
			SETTB99ID: '', //二级企业ID
			cityCodeModify: '',
			cityNameModify: '',
			modifyIF: '', //判断绑定，自建企业修改时可操作的字段
			// 账户绑定
			bindingShow: false,
			phoneBinding: '', //手机号
			nameBinding: '', //账户名称
			codeNumBinding: '', //验证码
			SETTB107ID: '',
			checkDisable: false,
			checkText: '获取验证码',
			countdownNum: 60,
			// 查看物料
			materShow: false,
			materList: [],
			materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
			categoryMaterial: '', //物料类别
			nameMaterial: '', //物料名称
			pageMaterial: 1, //默认列表页码
			limitMaterial: 10, //每页的条数
			pagingPageMaterial: 0, //分页--数据列表共有的条数
			currentPageMaterial: 1, //设置当前页默认为1
			// 新增
			materInsertShow: false,
			enterNameMaterialAdd: '', //企业名称
			nameMaterialAdd: '', //物料名称
			wholesalePriceAdd: '', //零售价格
			// agreementPriceAdd:'', //协议价格
			materialTypeAdd: '', //物料类型
			materialTypeList: [],
			unitMeasurementAdd: '', //计量单位
			// 修改
			materupdateShow: false,
			discountShow: false,
			enterNameMaterialModify: '', //企业名称
			nameMaterialModify: '', //物料名称
			wholesalePriceModify: '', //零售价格
			agreementPriceModify: '', //服务费8.5开票比例
			agreementedwPriceModify: '', //服务费8.8开票比例
			ORMTB401CA23: '',//服务费9.1开票比例
			materialTypeModify: '', //物料类型
			unitMeasurementModify: '', //计量单位
			MaterialModify109ID: '', //物料ID
			wholesalePriceBefore: '', //修改之前的价格
			bb: {},
			locationShow: false,
			locationSetObj: {},
			kwSelectArr: [{
				value: '有料',
				label: '有料'
			}, {
				value: '无料',
				label: '无料'
			}],
			kwSelectVal: '',
			tableData1: [{
				id: '小12',
				name: '一级',
				amount1: '234',
				amount2: '3.2',
				amount3: 10
			}, {
				id: '小12',
				name: '二级',
				amount1: '165',
				amount2: '4.43',
				amount3: 12
			}, {
				id: '小12',
				name: '三级',
				amount1: '324',
				amount2: '1.9',
				amount3: 9
			}, {
				id: '小12',
				name: '四级',
				amount1: '621',
				amount2: '2.2',
				amount3: 17
			}, {
				id: '小12',
				name: '五级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '小12',
				name: '六级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '小12',
				name: '七级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '小12',
				name: '八级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '大12',
				name: '一级',
				amount1: '234',
				amount2: '3.2',
				amount3: 10
			}, {
				id: '大12',
				name: '二级',
				amount1: '165',
				amount2: '4.43',
				amount3: 12
			}, {
				id: '大12',
				name: '三级',
				amount1: '324',
				amount2: '1.9',
				amount3: 9
			}, {
				id: '大12',
				name: '四级',
				amount1: '621',
				amount2: '2.2',
				amount3: 17
			}, {
				id: '大12',
				name: '五级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '大12',
				name: '六级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '大12',
				name: '七级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			},
			{
				id: '大12',
				name: '八级',
				amount1: '539',
				amount2: '4.1',
				amount3: 15
			}
			],
			arr1: [],
			arr2: [],
			jgcjtitle: '',
			kpObj: {},

			// resPreferentialList:[
			// 	{
			// 		label:1,
			// 		value:1,
			// 	}
			// ],
			// resTerpList:[
			// 	{
			// 		label:1,
			// 		value:1,
			// 	}
			// ],
			solelist: [],
			// 历史缓存
			currentUrl: this.$route.path,
			historyInfo: "",
			settb426id: '',
			settb99id: '',
			settb100ca00: '',
			settb99ca00: '',
			settb426ca01: null,
			settb426ca02: null,
			settb426ca03: null,
			settb426ca04: null,
			settb426ca05: null,
			settb426ca06: null,
			settb426ca07: null,
			settb426ca08: null,
			settb426ca09: null,
			settb426ca10: null,
			settb426ca11: null,
			settb426ca12: 0,
			settb426ca13: '',
			preferentialType:[]
		};
	},
	watch: {
		//监听器的作用就是用来监听数据是否发生了变化，变化后可以进行一些其他操作
		//只要没有发生变化，就没有办法进行其他的操作
		bb: function (newData, oldData) {
			//newData是更新后的数据
			//oldData是旧数据
			// newData.tel = 1111;
			// console.log("监听变化:", newData, oldData);
		},
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		var path = this.$route.path;
		if (path === "/SalesystemCorporateAccount") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		this.userobj = this.$store.state.uobj;
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			// this.init();
		}




	},
	mounted() {
		// console.log(this.userobj.ormtb400)
		this.pageList()
		this.querycityNameList()
		this.querypreferentialCode();
	},
	// 存储数据
	beforeDestroy() {
		var obj = {
			currentPage: this.currentPage, //当前页数
			page: this.page, //页码
			limit: this.limit, //每页条数
		};
		sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	},
	methods: {
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "15", //默认
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data;
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleInput(fieldName, value) {
			// 使用正则表达式，只允许数字和小数点
			// 限制只能有一个小数点
			const result = value.replace(/[^\d.]/g, '')
				.replace(/^\./g, '') // 不能以小数点开头
				.replace(/\.{2,}/g, '.') // 不能有连续的小数点
				.replace(/(\d*)\.(\d*)\./g, '$1.$2'); // 只能有一个小数点
			if (fieldName == 'settb426ca01') {
				this.settb426ca01 = result;
			} else if (fieldName == 'settb426ca02') {
				this.settb426ca02 = result;
			} else if (fieldName == 'settb426ca03') {
				this.settb426ca03 = result;
			} else if (fieldName == 'settb426ca04') {
				this.settb426ca04 = result;
			} else if (fieldName == 'settb426ca05') {
				this.settb426ca05 = result;
			} else if (fieldName == 'settb426ca06') {
				this.settb426ca06 = result;
			} else if (fieldName == 'settb426ca07') {
				this.settb426ca07 = result;
			} else if (fieldName == 'settb426ca08') {
				this.settb426ca08 = result;
			} else if (fieldName == 'settb426ca09') {
				this.settb426ca09 = result;
			} else if (fieldName == 'settb426ca10') {
				this.settb426ca10 = result;
			} else if (fieldName == 'settb426ca11') {
				this.settb426ca11 = result;
			}
		},
		setdates(arr) {
			var obj = {},
				k, arr1 = [];
			for (var i = 0, len = arr.length; i < len; i++) {
				k = arr[i].name; //需要合并的字段
				if (obj[k])
					obj[k]++;
				else
					obj[k] = 1;
			}
			// console.log(obj)
			//保存结果{el-'元素'，count-出现次数}
			for (var o in obj) {
				for (let i = 0; i < obj[o]; i++) {
					if (i === 0) {
						this.arr1.push(obj[o])
					} else {
						this.arr1.push(0)
					}
				}
			}
			// console.log(this.arr1);

		},



		// objectSpanMethod({
		// 	row,
		// 	column,
		// 	rowIndex,
		// 	columnIndex
		// }) {
		// 	if (columnIndex === 0) {
		// 		if (rowIndex % 2 === 0) {
		// 			return {
		// 				rowspan: 2,
		// 				colspan: 1
		// 			};
		// 		} else {
		// 			return {
		// 				rowspan: 0,
		// 				colspan: 0
		// 			};
		// 		}
		// 	}
		// },

		objectSpanMethod({
			row,
			column,
			rowIndex,
			columnIndex
		}) {
			if (columnIndex === 0) {
				let _row = this.arr1[rowIndex]
				let _col = this.arr1[rowIndex] > 0 ? 1 : 0
				return [_row, _col]
			}
		},


		reconstructionStuData(data) {
			// console.log(data)
			if (!Array.isArray(data)) return [];

			let tmpData = [];
			data.forEach((item, i) => {
				//有二级数据的进行处理
				if (Array.isArray(item.subject) && item.subject.length > 0) {
					//循环成绩
					item.subject.forEach((sub, j) => {
						let subData = {};
						if (j == 0) {
							//子项第一行数据，和姓名信息同行
							subData = Object.assign({}, item, sub);
						}
						//其他行数据无须添加 姓名字段信息（第一行数据会合并到结束位置，填充后也会被覆盖）
						else {
							subData = Object.assign({}, sub);
						}
						//if end
						tmpData.push(subData);
					});
				}
				//subject无子项数据，保留当前位置输出
				else {
					tmpData.push(
						Object.assign({}, item)
					);
				}
			});
			return tmpData;
		},

		customerManagementQuery() { //获取客户等级列表
			this.ruleForm.grade = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.ruleForm.grade = res.data.data
					this.editRuleForm.grade = res.data.data


				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		handleCheckAllChange(val) { //客户等级全选
			// console.log(val)
			// console.log(this.addEdit)
			if (this.addEdit == 0) {
				this.checkedCitiesGrade = val ? this.ruleForm.grade : [];
				// console.log(this.checkedCitiesGrade)
				this.isIndeterminate = false;
				return
			}
			if (this.addEdit == 1) {
				if (val == true && this.addEdit == 1) {
					for (let i = 0; i < this.editRuleForm.grade.length; i++) {
						// if (this.editRuleForm.grade[i].containPreferential == 1) {
						this.checkedCitiesGrade.push(this.editRuleForm.grade[i].SETTB206CA00);
						// console.log(this.checkedCitiesGrade)
						// }
					}
				} else {
					this.checkedCitiesGrade = []
				}
				this.isIndeterminate = false;


			}


		},
		handleCheckedCitiesChange(value) { //客户等级单选
			let checkedCount = value.length;
			// console.log(checkedCount)
			this.checkAllGrade = checkedCount === this.ruleForm.grade.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.ruleForm.grade.length;
			// console.log(value)
		},
		tabClick(row, column, cell, event) {
			// console.log("row:", row);
			// console.log("column:", column);
			// console.log("column.index:", column.index);
			// console.log("column.label:", column.label);

			this.clickRowIndex = row.index;
			this.clickCellIndex = column.index;
			this.tabClickLabel = column.label;

		},
		// 失去焦点初始化
		inputBlur(row, event, column) {
			// console.log(row)
			// console.log(event)
			// console.log(column)
			this.clickRowIndex = null;
			this.clickCellIndex = null;
			this.tabClickLabel = "";
			// console.log("this.tableData:", this.tableData);
		},
		changeInput(row) {
			// console.log(row)

			this.notice = row.notice
			this.ORMTB401ID = row.ORMTB401ID
			this.noticeFun()
		},

		tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex;
		},

		// 把每一列的索引放进column
		tableCellClassName({
			column,
			columnIndex
		}) {
			column.index = columnIndex;
		},

		newlyAdd() {
			this.insertShow = true
			this.enterpriseNameAdd = '' //企业名称
			this.enterpriseAbbreviationAdd = '' //企业简称
			this.phoneNumberAdd = '' //手机号
			this.accountNameAdd = '' //账户名称
			this.accountBalanceAdd = '' //账户余额
			this.addressBalanceAdd = '' //地址
			this.uditTypeAdd = '1'
			this.cityNameAdd = ''
			this.cityCodeAdd = ''
		},
		querycityNameList() {
			var url = "/code/condtb01/selecList"
			var postData = {}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.cityNameList = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cityNameChange(e) {
			this.cityNameList.forEach((resitme) => {
				if (this.cityCodeAdd == resitme.CODETB01CA00) {
					this.cityNameAdd = resitme.CODETB01CA01;
				}
			});
		},
		materialMLClick(row) {
			this.insertMLShow = true
			this.objCjMasg = row
			this.customerManagementQuery()
			this.checkedCitiesGrade = []
			this.isIndeterminate = false
			this.checkAllGrade = false
		},

		// 保存抹零设置
		preservationML() {
			if (this.checkedCitiesGrade.length == 0) {
				this.$message({
					message: '请选择客户等级',
					type: 'error'
				});
				return
			}
			let newArrKhdj = []
			this.checkedCitiesGrade.forEach(function (value, index, array) {
				newArrKhdj.push(value.SETTB206CA00)
			})
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.objCjMasg)
			var postData = {
				ORMTB401ID: this.objCjMasg.ORMTB401ID,
				ORMTB401CA08: newArrKhdj.toString() //客户等级
			}
			var url = "/orm/ormtb401/updateML";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertMLShow = false;
					this.$message({
						message: '设置成功',
						type: 'success'
					});

					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},

		preservationXGML() { //修改抹零设置
			if (this.checkedCitiesGrade.length == 0) {
				this.$message({
					message: '请选择客户等级',
					type: 'error'
				});
				return
			}

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB401ID: this.objCjMasg.ORMTB401ID,
				ORMTB401CA08: this.checkedCitiesGrade.toString() //客户等级
			}
			var url = "/orm/ormtb401/updateML";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertXGMLShow = false;
					this.$message({
						message: '修改成功',
						type: 'success'
					});

					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})

		},

		preservationGBML(row) { //关闭抹零
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB401ID: row.ORMTB401ID,
				ORMTB401CA08: '' //客户等级
			}
			var url = "/orm/ormtb401/updateML";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertXGMLShow = false;
					this.$message({
						message: '关闭成功',
						type: 'success'
					});

					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},

		// 新增
		preservationAdd() {
			if (this.enterpriseNameAdd.trim().length == 0) return this.$message.error('请输入企业名称')
			if (this.enterpriseAbbreviationAdd.trim().length == 0) return this.$message.error('请输入企业简称')
			if (this.phoneNumberAdd.trim().length == 0) return this.$message.error('请输入手机号')
			if (this.phoneNumberAdd != '') {
				var regP = /^1[3-9][0-9]{9}$/;
				if (!regP.test(this.phoneNumberAdd))
					return this.$message.error("请输入有效手机号");
			}
			if (this.accountNameAdd.trim().length == 0) return this.$message.error('请输入账户名称')
			if (this.accountBalanceAdd === '') return this.$message.error('请输入账户余额')
			if (this.addressBalanceAdd.trim().length == 0) return this.$message.error('请输入地址')
			if (this.cityCodeAdd.trim().length == 0) return this.$message.error('请选择市名称')
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB100CA00: this.enterpriseNameAdd, //企业名称
				SETTB100CA01: this.enterpriseAbbreviationAdd, //企业简称
				ORMTB400CA02: this.phoneNumberAdd, //手机号
				ORMTB401CA02: this.accountNameAdd, //账户名称
				ORMTB401CA03: this.accountBalanceAdd, //账户余额
				SETTB99CA02: this.addressBalanceAdd, //地址
				SETTB100CA04: this.cityCodeAdd, //市代码
				SETTB100CA05: this.cityNameAdd, //市名称
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
				// Notice: this.notice, //公告
				// SETTB100CA03:this.uditTypeAdd
			}
			var url = "/orm/ormtb401/insert";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertShow = false;
					// this.$message({
					// 	message: '新增成功',
					// 	type: 'success'
					// });
					this.$alert('新增成功，请前去销售系统-优惠管理中为该新建企业设置等级优惠。', '消息', {
						confirmButtonText: '确定'
					})
					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},
		// 修改
		modify(item) {
			this.updateShow = true
			this.enterpriseNameModify = item.SETTB100CA00 //企业名称
			this.enterpriseAbbreviationModify = item.SETTB100CA01 //企业简称
			this.phoneNumberModify = item.SETTB99CA01 //手机号
			this.accountNameModify = item.ORMTB401CA02 //账户名称
			this.accountBalanceModify = item.ORMTB401CA03 //账户余额
			this.addressBalanceModify = item.SETTB99CA02 //地址
			this.ORMTB401ID = item.ORMTB401ID //帐户ID
			this.ORMTB401CA00 = item.ORMTB401CA00 //一级企业ID
			this.SETTB99ID = item.SETTB99ID //二级企业ID
			this.notice = item.notice,
				this.modifyIF = item.ORMTB401CA01 || 'ZJ'
			this.uditTypeUpdate = item.SETTB100CA03 || '1'
			this.cityCodeModify = item.SETTB100CA04
			this.cityNameModify = item.SETTB100CA05
		},
		cityNameChangeModify(e) {
			this.cityNameList.forEach((resitme) => {
				if (this.cityCodeModify == resitme.CODETB01CA00) {
					this.cityNameModify = resitme.CODETB01CA01;
				}
			});
		},
		preservationModify() {
			// console.log(this.phoneNumberModify)
			if (this.enterpriseNameModify.trim().length == 0) return this.$message.error('请输入企业名称')
			if (this.enterpriseAbbreviationModify.trim().length == 0) return this.$message.error('请输入企业简称')
			if (this.phoneNumberModify == undefined) return this.$message.error('请输入手机号')
			if (this.phoneNumberModify.trim().length == 0) return this.$message.error('请输入手机号')
			if (this.phoneNumberModify != '') {
				var regP = /^1[3-9][0-9]{9}$/;
				if (!regP.test(this.phoneNumberModify))
					return this.$message.error("请输入有效手机号");
			}
			if (this.accountNameModify.trim().length == 0) return this.$message.error('请输入账户名称')
			if (this.accountBalanceModify === '') return this.$message.error('请输入账户余额')
			if (this.addressBalanceModify.trim().length == 0) return this.$message.error('请输入地址')
			if (this.cityCodeModify.trim().length == 0) return this.$message.error('请选择市名称')
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB100CA00: this.enterpriseNameModify, //企业名称
				SETTB100CA01: this.enterpriseAbbreviationModify, //企业简称
				ORMTB400CA02: this.phoneNumberModify, //手机号
				ORMTB401CA02: this.accountNameModify, //账户名称
				ORMTB401CA03: this.accountBalanceModify, //账户余额
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
				ORMTB401ID: this.ORMTB401ID, //帐户ID
				SETTB100ID: this.ORMTB401CA00, //一级企业ID
				SETTB99ID: this.SETTB99ID, //二级企业ID
				// notice: this.notice,
				SETTB99CA02: this.addressBalanceModify, //地址
				SETTB100CA03: this.uditTypeUpdate,
				SETTB100CA04: this.cityCodeModify, //市代码
				SETTB100CA05: this.cityNameModify, //市名称
			}
			var url = "/orm/ormtb401/compile";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.updateShow = false;
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},
		captchaBinding(item) {
			this.bindingShow = true
			// this.phoneBinding=item.SETTB99CA01
			this.phoneBinding = ''
			this.nameBinding = '';
			this.codeNumBinding = '';
			this.SETTB107ID = '';
			// this.nameBinding=item.ORMTB401CA02
			this.ORMTB401ID = item.ORMTB401ID
			this.ORMTB401CA00 = item.ORMTB401CA00
		},
		phoneBindingUp() {

			var postData = {
				ORMTB400CA02: this.phoneBinding, //手机号
				ORMTB401CA00: this.ORMTB401CA00, //一级企业id
			}
			var url = "/orm/ormtb401/checkOrmtb400ca02";
			if (this.phoneBinding.length == 11) {
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						var moLists = res.data.data;
						this.nameBinding = moLists[0].SETTB107CA00;
						this.SETTB107ID = moLists[0].SETTB107ID;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			} else if (this.phoneBinding.length == 0) {
				this.nameBinding = '';
				this.SETTB107ID = '';
			}
		},

		noticeFun() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB401ID: this.ORMTB401ID, //ID
				notice: this.notice, //公告
			}
			var url = "/orm/ormtb401/updateNotice";

			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			})
				.catch(() => {
					loading.close();
				})

		},

		// preservationBinding() {
		// 	if (this.phoneBinding.trim().length == 0) return this.$message.error('请输入手机号')
		// 	if (this.phoneBinding != '') {
		// 		var regP = /^1[3-9][0-9]{9}$/;
		// 		if (!regP.test(this.phoneBinding))
		// 			return this.$message.error("请输入有效手机号");
		// 	}
		// 	var NumBin = /^\d{6}$/;
		// 	if (!NumBin.test(this.codeNumBinding)) return this.$message.error('请输入六位有效验证码')
		// 	let loading = this.$loading({
		// 		lock: true,
		// 		text: '请求中...',
		// 		spinner: 'el-icon-loading',
		// 		background: 'rgba(0, 0, 0, 0.5)'
		// 	});
		// 	var postData = {
		// 		ORMTB400CA02: this.phoneBinding, //手机号
		// 		PERTB006CA00: this.codeNumBinding,
		// 		ORMTB401ID: this.ORMTB401ID,
		// 		SETTB107ID: this.SETTB107ID,
		// 		SETTB107CA00: this.nameBinding,
		// 	}
		// 	var url = "/orm/ormtb401/update";
		// 	this.axios.post(url, postData).then(res => {
		// 		// console.log(res)
		// 		if (res.data.code == 200) {
		// 			this.bindingShow = false;
		// 			this.$message({
		// 				message: '修改成功',
		// 				type: 'success'
		// 			});
		// 			this.pageList();
		// 		} else {
		// 			this.$message({
		// 				message: res.data.message,
		// 				type: 'error'
		// 			});
		// 		}
		// 		setTimeout(() => {
		// 			loading.close()
		// 		}, 300)
		// 	}).catch(() => {
		// 		loading.close();
		// 	})
		// },
		countdown() { //倒计时
			// console.log(this.ueseinfo.name)
			if ((/^[1][3-9][0-9]{9}$/.test(this.phoneBinding))) {
				this.checkDisable = true
				this.countdownNum--
				this.checkText = `${this.countdownNum}后重新获取`
				var time = setInterval(() => {
					if (this.countdownNum == 0) {
						clearInterval(time)
						this.countdownNum = 60
						this.checkText = '获取验证码'
						this.checkDisable = false
						return
					} else {
						this.countdownNum--
						var num = this.countdownNum < 10 ? ('0' + this.countdownNum) : this.countdownNum
						this.checkText = `${num}后重新获取`
					}
				}, 1000)
				var url = '/orm/ormtb401/getCode'
				var data = {
					ORMTB400CA02: this.phoneBinding
				}
				this.axios.post(url, data).then((res) => {
					// console.log(res)
					if (res.data.code != 200) {
						this.$message.error('获取验证码失败，请重试！')
					}
				})
			} else {
				this.$message.error('请输入有效手机号')
			}
		},
		// 查看物料
		// 新增
		MaterialAdd() {
			this.materInsertShow = true
			// this.enterNameMaterialAdd='' //企业名称
			this.nameMaterialAdd = '' //物料名称
			this.wholesalePriceAdd = '' //零售价格
			// this.agreementPriceAdd='' //协议价格
			this.materialTypeAdd = '' //物料类型
			this.unitMeasurementAdd = '' //计量单位
			this.queryMaterialTypeLsit('')
		},
		preservationMaterialAdd() {
			if (this.nameMaterialAdd.trim().length == 0) return this.$message.error('请输入物料名称')
			if (this.wholesalePriceAdd === '') return this.$message.error('请输入零售价格')
			// if (this.agreementPriceAdd=== '') return this.$message.error('请输入协议价格')
			if (this.materialTypeAdd.trim().length == 0) return this.$message.error('请输入物料类型')
			if (this.unitMeasurementAdd.trim().length == 0) return this.$message.error('请输入计量单位')
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB99CA00: this.enterNameMaterialAdd, //二级企业名称
				SETTB109CA00: this.nameMaterialAdd, //物料名称
				SETTB109CA01: this.wholesalePriceAdd, //零售价格
				// SETTB109CA01: this.agreementPriceAdd, //协议价格
				SETTB206CA00: this.materialTypeAdd, //物料类型
				SETTB109CA05: this.unitMeasurementAdd, //计量单位
				SETTB109CD01: this.ORMTB401CA00, //一级企业id
				// ORMTB401ID: this.ORMTB401ID,//一级企业id
				SETTB99ID: this.SETTB99ID, //二级企业id
			}
			var url = "/set/settb109/insert";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.materInsertShow = false;
					this.$message({
						message: '新增成功',
						type: 'success'
					});
					this.pageMaterialList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},
		queryMaterialTypeLsit(type) {
			// console.log(type)
			if (type === 0) {
				this.materialTypeList = [{
					SETTB206CA00: "",
					SETTB206CA01: "全部"
				}];
			} else {
				this.materialTypeList = []
			}
			var url = "/set/settb109/selectSETTB206CA01"
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					var data = res.data.data
					if (type === 0) {
						this.materialTypeList = [...this.materialTypeList, ...data];
					} else {
						this.materialTypeList = data
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		MaterialModify(item) {
			this.materupdateShow = true
			this.queryMaterialTypeLsit('')
			this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
			this.nameMaterialModify = item.SETTB109CA00 //物料名称
			this.wholesalePriceModify = item.SETTB109CA01 //价格
			this.wholesalePriceBefore = item.SETTB109CA01 //价格
			this.materialTypeModify = item.SETTB206CA00 //物料类型
			this.unitMeasurementModify = item.SETTB109CA05 //计量单位
			this.MaterialModify109ID = item.SETTB109ID
		},
		logDetail(item) {
			var postData = {
				settb99id: item.settb99id,
				// ORMTB401ID: item.ORMTB401ID
			}
			var url = "/set/settb426/selectLog";
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.logShow = true;
					this.tableDetail = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				// loading.close();
			})

		},
		DiscountModify(item) {
			this.kpObj = item
			this.discountShow = true;
			// this.agreementPriceModify = item.ORMTB401CA20
			// this.agreementedwPriceModify = item.ORMTB401CA21
			// this.ORMTB401CA23 = item.ORMTB401CA23;
			// this.kaipiaoValue = item.ORMTB401CA12
			// this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
			this.settb426id = item.settb426id;
			this.settb99id = item.settb99id;
			this.settb100ca00 = item.settb100ca00;
			this.settb99ca00 = item.settb99ca00;
			this.settb426ca01 = item.settb426ca01;
			this.settb426ca02 = item.settb426ca02;
			this.settb426ca03 = item.settb426ca03;
			this.settb426ca04 = item.settb426ca04;
			this.settb426ca05 = item.settb426ca05;
			this.settb426ca06 = item.settb426ca06;
			this.settb426ca07 = item.settb426ca07;
			this.settb426ca08 = item.settb426ca08;
			this.settb426ca09 = item.settb426ca09;
			this.settb426ca10 = item.settb426ca10;
			this.settb426ca11 = item.settb426ca11;
			this.settb426ca12 = item.settb426ca12;
			this.settb426ca13 = item.settb426ca13;
		},
		locationSet(row) {
			this.locationShow = true
			this.locationSetObj = row
		},

		preservationMaterialModify() {
			if (this.nameMaterialModify.trim().length == 0) return this.$message.error('请输入物料名称')
			if (this.wholesalePriceModify === '') return this.$message.error('请输入价格')
			// if (this.agreementPriceModify=== '') return this.$message.error('请输入协议价格')
			if (this.materialTypeModify.trim().length == 0) return this.$message.error('请选择物料类型')
			if (this.unitMeasurementModify.trim().length == 0) return this.$message.error('请输入计量单位')
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
				SETTB109ID: this.MaterialModify109ID, //物料ID
				SETTB109CA00: this.nameMaterialModify, //物料名称
				SETTB109CA01: this.wholesalePriceModify, //修改之后价格
				// SETTB109CA01: this.agreementPriceModify, //协议价格
				SETTB206CA00: this.materialTypeModify, //物料类型
				SETTB109CA05: this.unitMeasurementModify, //计量单位
				before: this.wholesalePriceBefore, //修改之前的价格
				SETTB100ID: this.ORMTB401CA00, //一级企业id
				SETTB99ID: this.SETTB99ID, //二级企业id
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
				ORMTB408CA02: this.userobj.pertb005.pertb005ca02, //当前登录人名称
			}
			var url = "/set/settb109/update";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.materupdateShow = false;
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.pageMaterialList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},

		preservationDiscountModify() {
			if (!this.settb426ca13) {
				this.$message.warning('请选择业务公司')
				return
			}
			if (!this.settb426ca01) {
				this.$message.warning('请输入一级客户开票比例')
				return
			}
			if (!this.settb426ca02) {
				this.$message.warning('请输入二级客户开票比例')
				return
			}
			if (!this.settb426ca03) {
				this.$message.warning('请输入三级客户开票比例')
				return
			}
			if (!this.settb426ca04) {
				this.$message.warning('请输入四级客户开票比例')
				return
			}
			if (!this.settb426ca05) {
				this.$message.warning('请输入五级客户开票比例')
				return
			}
			if (!this.settb426ca06) {
				this.$message.warning('请输入六级客户开票比例')
				return
			}
			if (!this.settb426ca07) {
				this.$message.warning('请输入七级客户开票比例')
				return
			}
			if (!this.settb426ca08) {
				this.$message.warning('请输入八级客户开票比例')
				return
			}
			if (!this.settb426ca09) {
				this.$message.warning('请输入九级客户开票比例')
				return
			}
			if (!this.settb426ca10) {
				this.$message.warning('请输入十级客户开票比例')
				return
			}
			if (!this.settb426ca11) {
				this.$message.warning('请输入十一级客户开票比例')
				return
			}
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				// ORMTB401ID: this.kpObj.ORMTB401ID,
				// ORMTB401CA12: this.kaipiaoValue,
				// ORMTB401CA20: this.agreementPriceModify,
				// ORMTB401CA21: this.agreementedwPriceModify,
				// ORMTB401CA23: this.ORMTB401CA23
				settb426id: this.settb426id,
				settb99id: this.settb99id,
				settb100ca00: this.settb100ca00,
				settb99ca00: this.settb99ca00,
				settb426ca01: this.settb426ca01,
				settb426ca02: this.settb426ca02,
				settb426ca03: this.settb426ca03,
				settb426ca04: this.settb426ca04,
				settb426ca05: this.settb426ca05,
				settb426ca06: this.settb426ca06,
				settb426ca07: this.settb426ca07,
				settb426ca08: this.settb426ca08,
				settb426ca09: this.settb426ca09,
				settb426ca10: this.settb426ca10,
				settb426ca11: this.settb426ca11,
				settb426ca12: this.settb426ca12,
				settb426ca13: this.settb426ca13,
			}
			var url = "/set/settb426/update";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.discountShow = false;
					this.$message({
						message: '成功',
						type: 'success'
					});
					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})

		},
		locationSetObjModify() {
			// console.log(this.locationSetObj.SETTB109CB06)
			if (!this.locationSetObj.SETTB109CB06) return this.$message.error('请输入库位信息')

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
				SETTB109ID: this.locationSetObj.SETTB109ID, //物料ID
				SETTB109CB06: this.locationSetObj.SETTB109CB06
			}
			var url = "/set/settb109/updateSETTB109CB06";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.locationShow = false;
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.pageMaterialList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},

		// 禁用
		disableClick(row) {
			var SETTB109ID = row["SETTB109ID"]; //物料id
			var SETTB109CA02 = row["SETTB109CA02"]; //状态--1启用，0禁用
			var state;
			var ediqj
			if (SETTB109CA02 == "禁用") {
				state = 1;
				ediqj = 1;
			} else if (SETTB109CA02 == "启用") {
				state = 0;
				ediqj = 0
			}
			var postData = {
				SETTB109ID: SETTB109ID, //物料id
				SETTB109CA02: state, //状态
				SETTB109CB04: ediqj,
			};
			var url = "/set/settb109/updateSettb109ca02";
			if (state == 1) {
				this.$confirm("此操作将启用该条数据, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.axios.post(url, postData).then((res) => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageMaterialList();
							this.$message({
								type: "success",
								message: "启用成功!",
							});
						} else {
							this.$message({
								message: res.data.message,
								type: "error",
							});
						}
					});
				});
			} else if (state == 0) {
				this.$confirm("此操作将禁用该条数据, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.axios
						.post(url, postData)
						.then((res) => {
							// console.log(res)
							if (res.data.code == 200) {
								this.pageMaterialList();
								this.$message({
									type: "success",
									message: "禁用成功!",
								});
							} else {
								this.$message({
									message: res.data.message,
									type: "error",
								});
							}
						})
						.catch((err) => {
							this.$baseAPI.axiosstatusMsg(err);
						});
				});
			}
		},

		tgClick(row) {
			var url = "set/settb109/updateSETTB109CA11"
			var SETTB109ID = row["SETTB109ID"]; //物料id
			var SETTB109CA09 = row["SETTB109CA09"]; //视频路径
			var postData = {
				SETTB109ID: SETTB109ID,
				SETTB109CA11: 1,
				SETTB109CA09: SETTB109CA09
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.pageMaterialList();
					this.$message({
						type: "success",
						message: "已通过!",
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},

		// 是否优惠
		changeTable(row) {
			var str = row.SETTB109CA08 == 0 ? '关闭' : '开启'
			var url = "/set/settb109/updateSETTB109CA08"
			var postData = {
				SETTB109ID: row.SETTB109ID,
				SETTB109CA08: row.SETTB109CA08,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message({
						message: `${str}成功`,
						type: 'success'
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
				this.pageMaterialList()
			}).catch(() => {
				loading.close()
				this.pageMaterialList()
			})
		},

		// 是否启用多账户
		changeMultipleAccountsTable(row) {
			var str = row.SETTB109CB09 == 0 ? '关闭' : '开启'
			var url = "/set/settb109/updateSettb109CB09"
			var postData = {
				SETTB109ID: row.SETTB109ID,
				SETTB109CB09: row.SETTB109CB09,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message({
						message: `${str}成功`,
						type: 'success'
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
				this.pageMaterialList()
			}).catch(() => {
				loading.close()
				this.pageMaterialList()
			})
		},

		materialClick(item) {
			this.materShow = true
			this.categoryMaterial = ''
			this.nameMaterial = ''
			this.ORMTB401CA00 = item.ORMTB401CA00
			this.SETTB99ID = item.SETTB99ID
			this.enterNameMaterialAdd = item.SETTB99CA00
			this.materiaShowZJ = item.ORMTB401CA01 //企业是绑定还是自建
			this.ORMTB401ID = item.ORMTB401ID //帐户ID
			this.pageMaterial = 1

			this.queryMaterialTypeLsit(0)
			this.pageMaterialList()
		},

		// 查看价格
		jgApiFun(SETTB99ID, SETTB99CA00) {
			var url = "/orm/ormtb401/loadTree"
			var postData = {
				SETTB99ID: SETTB99ID,
				SETTB99CA00: SETTB99CA00,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableData1 = res.data.data.trees
					this.setdates(this.tableData1)
					// this.$nextTick(() => {
					// 	this.JGechartsVive();
					// });
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},


		materialJGClick(row) {
			// console.log(row)
			this.jgApiFun(row.SETTB99ID, row.SETTB99CA00)
			this.jgcjtitle = row.SETTB100CA00
			this.insertJGShow = true


		},
		initEchs() {
			let myChart = echarts.init(this.$refs.maim)
			this.$nextTick(() => {
				option && myChart.setOption(option)
				const eleArr = Array.from(new Set(myChart._chartsViews[0]._data._graphicEls))
				// const treeDepLength = myChart._chartsViews[0]._data.tree.root.height                            // 获取树的高度
				// const itemHeight = 100       // 设置每层树的间距（垂直型树高）
				// let currentHeight = itemHeight * (treeDepLength + 1) || itemHeight
				const itemHeight = 30
				const currentHeight = itemHeight * (eleArr.length - 1) || itemHeight
				const newHeight = Math.max(currentHeight, itemHeight)
				this.chartHeight = newHeight
				myChart.resize({
					height: newHeight
				})
			})
		},
		JGechartsVive() {
			let myChart = echarts.init(document.getElementById('JGChart'))

			var option;
			option = {
				tooltip: {
					trigger: 'item',
					triggerOn: 'mousemove'
				},
				// legend: {
				// 	top: '2%',
				// 	left: '3%',
				// 	orient: 'vertical',
				// 	data: [{
				// 			name: 'tree1',
				// 			icon: 'rectangle'
				// 		},
				// 		{
				// 			name: 'tree2',
				// 			icon: 'rectangle'
				// 		}
				// 	],
				// 	borderColor: '#c23531'
				// },
				series: [{
					type: 'tree',
					name: 'tree2',
					data: [this.jgData],
					top: '0',
					left: '10%',
					bottom: '10%',
					right: '10%',
					avoidLabelOverlap: true, //防止标签重叠
					roam: true, //移动+缩放  'scale' 或 'zoom'：只能够缩放。 'move' 或 'pan'：只能够平移。
					scaleLimit: { //缩放比例
						min: 0.7, //最小的缩放值
						max: 4, //最大的缩放值  
					},

					layout: 'orthogonal', //树图布局，orthogonal水平垂直方向，radial径向布局 是指以根节点为圆心，每一层节点为环，一层层向外
					orient: 'TB', //树形方向  TB为上下结构  LR为左右结构
					// nodePadding: 100,//结点间距 （发现没用）
					//layerPadding: 30,//连接线长度 （发现没用）
					symbol: 'circle', //图形形状  rect方形  roundRect圆角 emptyCircle圆形 circle实心圆
					symbolSize: 14, //状态大小
					edgeShape: 'polyline', //线条类型  curve曲线
					initialTreeDepth: 6, //初始展开的层级
					// expandAndCollapse: true, //子树折叠和展开的交互，默认打开
					lineStyle: { //结构线条样式
						width: 0.7,
						color: '#1E9FFF',
						type: 'broken'
					},
					label: { //节点文本样式
						normal: {
							backgroundColor: '#81c5f7',
							position: 'bottom',
							verticalAlign: 'middle', //文字垂直对齐方式
							align: 'center',
							borderColor: '#1E9FFF',
							color: '#fff',
							borderWidth: 1,
							borderRadius: 5,
							padding: 5,
							height: 40,
							width: 100,
							offset: [0, 30], //节点文字与圆圈之间的距离
							fontSize: 15,
							// 节点文本阴影
							shadowBlur: 10,
							shadowColor: 'rgba(0,0,0,0.25)',
							shadowOffsetX: 0,
							shadowOffsetY: 2,
						}
					},

					// layout: 'radial',
					// symbol: 'emptyCircle',
					// symbol: 'emptyCircle',
					// orient: 'vertical',
					// symbolSize: 7,
					// label: {
					// 	position: 'left',
					// 	verticalAlign: 'middle',
					// 	align: 'right',
					// 	fontSize: 12
					// },
					leaves: {
						// label: {
						// 	position: 'right',
						// 	verticalAlign: 'middle',
						// 	align: 'left'
						// }

						label: {
							//backgroundColor: '#81c5f7',
							backgroundColor: '#fff',
							color: '#333',
							position: 'bottom',
							rotate: 0, //标签旋转。
							verticalAlign: 'middle',
							align: 'center',
							//文本框内文字超过6个字折行
							/* formatter: function(val) {
											 let strs = val.name.split(''); //字符串数组
											 let str = ''
											 for(let i = 0, s; s = strs[i++];) { //遍历字符串数组
												 str += s;
												 if(!(i % 6)) str += '\n'; //按需要求余，目前是一个字换一行
											 }
											 return str
											 }, */
							//或者 
							overflow: 'break', //break为文字折行，  truncate为文字超出部分省略号显示
							lineOverflow: 'truncate', //文字超出高度后 直接截取
						}

					},
					expandAndCollapse: true, //点击锚点显示或隐藏，true可以点击，false不可以点击
					emphasis: {
						focus: 'descendant'
					},
					animationDuration: 550,
					// initialTreeDepth: 3,
					animationDurationUpdate: 750
				}]
			};
			option && myChart.setOption(option);
			const eleArr = Array.from(new Set(myChart._chartsViews[0]._data._graphicEls))
			// const treeDepLength = myChart._chartsViews[0]._data.tree.root.height                            // 获取树的高度
			// const itemHeight = 100       // 设置每层树的间距（垂直型树高）
			// let currentHeight = itemHeight * (treeDepLength + 1) || itemHeight
			const itemHeight = 15
			const currentHeight = itemHeight * (eleArr.length - 1) || itemHeight
			const newHeight = Math.max(currentHeight, itemHeight)
			this.chartHeight = newHeight
			let layer_width = 15; // 兄弟节点之间的距离
			let currentWidth = layer_width * (eleArr.length - 1) || layer_width;
			let newWidth = Math.max(currentWidth, layer_width);
			this.chartWidth = newWidth + 'px';
			// myChart.resize({
			// 	// height: newHeight,
			// 	width:newWidth,
			// })
			window.onresize = function () {
				myChart.resize();
			}
		},
		undercarriageClick(item) { //下架厂家
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB401ID: item.ORMTB401ID,
				ORMTB401CA09: 1 //客户等级
			}
			var url = "/orm/ormtb401/underEnter";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertXGMLShow = false;
					this.$message({
						message: '下架成功',
						type: 'success'
					});

					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},
		groundingClick(item) { //上架厂家
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB401ID: item.ORMTB401ID,
				ORMTB401CA09: 0 //客户等级
			}
			var url = "/orm/ormtb401/underEnter";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.insertXGMLShow = false;
					this.$message({
						message: '上架成功',
						type: 'success'
					});

					this.pageList();
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close();
			})
		},

		modifyMLClick(row) {
			// console.log(row)
			this.customerManagementQuery()
			this.addEdit = 1
			this.objCjMasg = row
			var khmr = row.ORMTB401CA08.split(',') //客户等级

			this.checkedCitiesGrade = khmr;

			this.checkAllGrade = khmr.length === this.editRuleForm.grade.length;
			let _this = this
			setTimeout(function () {
				_this.checkAllGrade = khmr.length === _this.editRuleForm.grade.length;

				_this.isIndeterminate = khmr.length > 0 && khmr.length < _this.editRuleForm.grade.length;



			}, 500);

			this.insertXGMLShow = true
		},


		MaterialQuery() {
			this.pageMaterial = 1
			this.pageMaterialList()
		},
		// 列表
		pageMaterialList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB109CA03: this.categoryMaterial, //物料类别
				SETTB109CA00: this.nameMaterial, //物料名称
				SETTB109CD01: this.ORMTB401CA00, //一级企业id
				SETTB99ID: this.SETTB99ID, //二级企业ID
				ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
				page: this.pageMaterial,
				limit: this.limitMaterial
			}
			this.materList = [];
			var moList;
			var url = "/set/settb109/selectPageList";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 300)
				if (res.data.code == 200) {
					moList = res.data.data;
					for (var i = 0; i < moList.length; i++) {
						if (moList[i]["SETTB109CA02"] == 0) {
							moList[i]["SETTB109CA02"] = "禁用";
						} else if (moList[i]["SETTB109CA02"] == 1) {
							moList[i]["SETTB109CA02"] = "启用";
						}
					}
					this.materList = moList;
					this.pagingPageMaterial = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		handleSizeChangeMaterial(val) {
			this.pageMaterial = 1
			this.limitMaterial = val;
			this.pageMaterialList();
		},
		// 点击页码
		handleCurrentChangeMaterial(val) {
			this.pageMaterial = val;
			this.pageMaterialList();
		},
		// 企业
		accountBalanceAddUp() {
			var value = this.accountBalanceAdd;
			// this.accountBalanceAdd = this.clearNoNum(value);
			var num = this.clearNoNum(value);
			if (num <= 0) return
			if (num > 99999999.99)
				this.$message.error('单价高于最大限制99999999.99')
			num = num > 99999999.99 ? 99999999.99 : num
			this.accountBalanceAdd = num
		},
		accountBalanceModifyUp() {
			var value = this.accountBalanceModify;
			// this.accountBalanceModify = this.clearNoNum(value);
			var num = this.clearNoNum(value);
			if (num <= 0) return
			if (num > 99999999.99)
				this.$message.error('单价高于最大限制99999999.99')
			num = num > 99999999.99 ? 99999999.99 : num
			this.accountBalanceModify = num
		},
		// 物料
		wholesalePriceAddUp() {
			var value = this.wholesalePriceAdd;
			// this.wholesalePriceAdd = this.clearNoNum(value);
			var num = this.clearNoNum(value);
			if (num <= 0) return
			if (num > 99999999.99)
				this.$message.error('单价高于最大限制99999999.99')
			num = num > 99999999.99 ? 99999999.99 : num
			this.wholesalePriceAdd = num
		},
		// agreementPriceAddUp() {
		// 	var value = this.agreementPriceAdd;
		// 	this.agreementPriceAdd = this.clearNoNum(value);
		// },
		wholesalePriceModifyUp() {
			var value = this.wholesalePriceModify;
			// this.wholesalePriceModify = this.clearNoNum(value);
			var num = this.clearNoNum(value);
			if (num <= 0) return
			if (num > 99999999.99)
				this.$message.error('单价高于最大限制99999999.99')
			num = num > 99999999.99 ? 99999999.99 : num
			this.wholesalePriceModify = num
		},
		// agreementPriceModifyUp() {
		// 	var value = this.agreementPriceModify;
		// 	this.agreementPriceModify = this.clearNoNum(value);
		// },
		clearNoNum(value) {
			value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				value = parseFloat(value);
			}
			return value;
		},
		// 查询
		queryClick() {
			this.page = 1
			this.pageList()
		},
		// 列表
		pageList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				search: this.retrievalQuery,
				// SETTB94CA00: '1001', //对接平台代码
				// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级客户ID
				pageNum: this.page,
				pageSize: this.limit
			}
			this.tableData = [];
			var url = "/set/settb426/selectPage";
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				setTimeout(() => {
					loading.close()
				}, 300)
				if (res.data.code == 200) {
					this.tableData = res.data.data;
					// this.tableData.forEach(item => {
					// 	item.SETTB100CA03text = item.SETTB100CA03 == 1 ? '审核' : '不审核'
					// 	Object.assign(item, {
					// 		showInput: true
					// 	})
					// })
					// console.log(this.tableData)

					this.pagingPage = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		handleSizeChange(val) {
			this.page = 1
			this.limit = val;
			this.pageList();
		},
		// 点击页码
		handleCurrentChange(val) {
			this.page = val;
			this.pageList();
		},
	},
};
</script>

<style scoped>
.systemCorporateAccount {
	background-color: #f3f3f3;
}

.systemCorporateAccount-table {
	text-align: center;
}

.test111:active {
	background-color: red !important;
}

.systemCorporateAccount-display,
.systemCorporateAccount-wuliao-input {
	display: flex;
	flex-direction: row;
	align-items: center !important;
}

.systemCorporateAccount-optionSty {
	width: 140px;
	margin-right: 30px;
}

.systemCorporateAccount-wuliao-input>input {
	height: 40px;
	box-sizing: border-box;
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	padding-left: 5px;
}

.systemCorporateAccount-dialog {
	/* display: grid; */
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px 18px;
	padding: 4px 8px 0;
}

.systemCorporateAccount-dialog-li,
.level-systemCorporateAccount-dialog-li {
	display: grid;
	grid-template-columns: 130px minmax(0, 1fr);
	align-items: center;
	gap: 12px;
	width: auto;
	min-width: 0;
	padding: 10px 12px;
	border: 1px solid var(--fszs-border-soft);
	border-radius: 10px;
	background: #f8fbff;
	box-sizing: border-box;
}

.level-systemCorporateAccount-dialog-li {
	margin-bottom: 12px;
}

.systemCorporateAccount-dialog-li + .systemCorporateAccount-dialog-li {
	margin-top: 12px;
}

.SCADL-text {
	height: auto;
	line-height: 32px;
	font-size: 14px;
	color: var(--fszs-text-muted);
	font-weight: 500;
	text-align: right;
}

.SCADL-text span {
	color: var(--fszs-danger);
}

.SCADL-input {
	min-width: 0;
}

.SCADL-input input,
.SCADL-input .el-select .el-input__inner,
/deep/.SCADL-input .el-textarea .el-textarea__inner {
	height: 38px !important;
	line-height: 38px !important;
	padding: 0 12px;
	border: 1px solid var(--fszs-border) !important;
	border-radius: 9px;
	color: var(--fszs-text);
	font-size: 14px;
	background: #f8fbff;
	font-family: Microsoft YaHei;
	box-sizing: border-box;
}

/deep/.SCADL-input .el-textarea .el-textarea__inner {
	height: auto !important;
	min-height: 76px;
	line-height: 1.5 !important;
	padding: 9px 12px;
}

.SCADL-input input:focus,
.SCADL-input .el-select .el-input__inner:focus,
/deep/.SCADL-input .el-textarea .el-textarea__inner:focus {
	border-color: var(--fszs-primary) !important;
	background: #ffffff;
	box-shadow: var(--fszs-focus);
}

.Binding-input {
	display: flex;
	align-items: center;
	gap: 10px;
}

.Binding-input .el-button {
	height: 38px !important;
	line-height: 38px !important;
	width: auto !important;
	margin-left: 0;
}

.Binding-input .el-input {
	width: auto !important;
	flex: 1;
	height: 38px !important;
	line-height: 38px !important;
}

.Binding-input .el-input .el-input__inner {
	height: 38px !important;
	line-height: 38px !important;
}

.SCADL-input .el-select {
	width: 100%;
}

.systemCorporateAccount-dialog-btn {
	grid-column: 1 / -1;
	display: flex;
	justify-content: center;
	gap: 12px;
	margin-top: 12px;
	padding-top: 16px;
	border-top: 1px solid var(--fszs-border-soft);
}

.systemCorporateAccount-dialog-li .CADL-binding-input {
	border: none;
	outline: none;
}

.SCADL-btn input {
	display: inline-block;
	width: 65%;
}

.SCADL-btn .el-button {
	height: 30px;
	line-height: 30px;
	padding: 0 20px;
}

.systemCorporateAccount-dialog-operation-btn {
	margin-top: 20px;
}

.systemCorporateAccount-dialog .pulbic_oparetionBlock {
	padding-left: 0;
	padding-right: 0;
}

.systemCorporateAccount-dialog-operation-btn-add {
	background-color: #ffaa00;
}

.SCADL-input .el-select .el-input__inner {
	height: 40px !important;
	line-height: 40px !important;
}

.levelmang-table-KJ {
	width: 240px;
}

.JGChart {
	height: 615px;
}

/deep/.SCADL-input .el-textarea .el-textarea__inner {
	/* height: 40px;
		line-height: 30px; */
	width: 99.9%;
	padding-left: 10px;
	border: 1px solid #999;
	color: #333;
	font-size: 18px;
	border-radius: 5px;
	font-family: Microsoft YaHei;
	/* box-sizing: border-box; */
	/* font-weight: bold; */
}

.levelBox {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-top: 20px;
}

.invoice-setting-two-col {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
	margin-top: 12px;
}

.invoice-setting-two-col .systemCorporateAccount-dialog-li {
	margin-top: 0;
}

.invoice-setting-actions {
	gap: 60px;
}
.public_saleWater_chaxun {
	margin-left: 40px;
}
	.billOperationRecord {
		padding: 18px;
		background: transparent;
		color: var(--fszs-text);
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		gap: 12px 18px;
		padding: 16px 18px;
		margin-bottom: 16px;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
		box-shadow: var(--fszs-shadow-sm);
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_criteriaRange {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 12px 16px;
		margin: 0;
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_oparetionBlock_Menu {
		height: auto;
		min-height: 36px;
		align-items: center;
		margin: 0;
	}

	.billOperationRecord > .pulbic_oparetionBlock:first-child .public_lbSty {
		color: var(--fszs-text-muted);
		font-weight: 500;
	}

	.billOperationRecord .statistic {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		gap: 16px;
		margin: 0 0 16px;
	}

	.billOperationRecord .statistic-item {
		display: flex;
		align-items: center;
		gap: 10px;
		min-height: 72px;
		padding: 16px 18px;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
		box-shadow: var(--fszs-shadow-sm);
	}

	.billOperationRecord .statistic-item span:last-child {
		color: var(--fszs-text-strong) !important;
		font-weight: 600;
	}

	.billOperationRecord-table {
		padding: 16px 16px 0;
		border: 1px solid rgba(220, 230, 242, 0.96);
		border-radius: var(--fszs-radius-lg);
		background: #ffffff;
		box-shadow: var(--fszs-shadow-sm);
		overflow: hidden;
	}

	.billOperationRecord-table .el-table {
		border-radius: 12px;
		overflow: hidden;
	}

	.billOperationRecord-table .el-table th {
		background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%) !important;
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.billOperationRecord-table .el-table td,
	.billOperationRecord-table .el-table th {
		padding: 9px 0;
	}

	.billOperationRecord .customerManagementPC-table-btn {
		display: flex;
		justify-content: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.billOperationRecord .customerManagementPC-page,
	.billOperationRecord .billOperationRecord-page,
	.billOperationRecord .pulbic_pagesize {
		display: flex;
		justify-content: flex-end;
		padding: 12px 0 4px;
		margin-top: 12px;
	}

	.billOperationRecord .customerManagementPC-add-customer,
	.billOperationRecord .CustomerfillingDig-tab,
	.billOperationRecord .salesWatersStatisticsPC-saleWaterDetails {
		padding: 4px 8px 0;
	}

	.billOperationRecord .customerManagementPC-add-customer-li,
	.billOperationRecord .CustomerfillingDig-tab-li,
	.billOperationRecord .rechargeType-tab-li,
	.billOperationRecord .systemCorporateAccount-dialog-li {
		align-items: center;
		gap: 12px;
		padding: 10px 12px;
		border: 1px solid var(--fszs-border-soft);
		border-radius: 10px;
		background: #f8fbff;
	}

	.billOperationRecord .customerManagementPC-add-customer-li + .customerManagementPC-add-customer-li,
	.billOperationRecord .CustomerfillingDig-tab-li + .CustomerfillingDig-tab-li,
	.billOperationRecord .rechargeType-tab-li + .rechargeType-tab-li,
	.billOperationRecord .systemCorporateAccount-dialog-li + .systemCorporateAccount-dialog-li {
		margin-top: 12px;
	}

	.billOperationRecord .customerManagementPC-add-customer-li-name,
	.billOperationRecord .CustomerfillingDig-tab-li-text,
	.billOperationRecord .rechargeType-tab-li-text,
	.billOperationRecord .SCADL-text {
		color: var(--fszs-text-muted);
		font-weight: 500;
	}

	.billOperationRecord .customerManagementPC-add-customer-li-ipt input,
	.billOperationRecord .CustomerfillingDig-tab-li-ipt input,
	.billOperationRecord .rechargeType-tab-li-ipt input,
	.billOperationRecord .SCADL-input input,
	.billOperationRecord .SCADL-input .el-input__inner {
		height: 34px;
		line-height: 34px;
		padding: 0 10px;
		border: 1px solid var(--fszs-border);
		border-radius: 8px;
		background: #ffffff;
		color: var(--fszs-text);
		box-sizing: border-box;
	}

	.billOperationRecord .customerManagementPC-add-customer-btn,
	.billOperationRecord .CustomerfillingDig-tab-btn,
	.billOperationRecord .salesWatersStatisticsPC-saleWaterDetails-btn {
		display: flex;
		justify-content: center;
		gap: 12px;
		margin: 22px 0 6px;
	}

	.billOperationRecord .public_icon_width {
		min-width: 78px;
		height: 30px;
		padding: 0 12px;
		border-radius: 7px;
	}

	.billOperationRecord .public_icon_margin + .public_icon_margin {
		margin-left: 8px;
	}

	.levelmang-title {
		gap: 8px;
		margin-bottom: 14px;
		padding: 4px;
		border-radius: 10px;
		background: #f1f6fb;
		color: var(--fszs-text-muted);
	}

	.levelmang-title div {
		padding: 8px 18px;
		border-radius: 8px;
		background-color: transparent;
		font-weight: 500;
	}

	.levelmang-title .levelmang-title-active {
		background: linear-gradient(135deg, var(--fszs-primary), #3aa0ff);
		color: #ffffff;
		box-shadow: 0 6px 14px rgba(23, 139, 255, 0.18);
	}

	.levelmang-table {
		margin: 0;
		padding: 0;
		border: 1px solid var(--fszs-border);
		border-radius: 12px;
		background: #ffffff;
		overflow: auto;
	}

	.levelmang-table > li {
		min-width: 860px;
	}

	.levelmang-table-head {
		position: sticky;
		top: 0;
		z-index: 2;
		background: linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%);
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.levelmang-table-head > div {
		height: 42px;
		line-height: 42px;
		border-left: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-CQ-list {
		border-bottom: 1px solid var(--fszs-border-soft);
		background: #fbfdff;
		color: var(--fszs-text-strong);
		font-weight: 600;
	}

	.levelmang-table-li {
		color: var(--fszs-text);
	}

	.levelmang-table-li-tab-li {
		border-bottom: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-li-tab-li > div {
		height: 46px;
		line-height: 46px;
		border-left: 1px solid var(--fszs-border-soft);
	}

	.levelmang-table-li-tab-li > div > input,
	.levelmang-table-ZK input,
	.levelmang-table-YH input {
		width: 96px;
		height: 32px;
		line-height: 32px;
		padding: 0 8px;
		border: 1px solid var(--fszs-border);
		border-radius: 8px;
		background: #ffffff;
		color: var(--fszs-text);
		box-sizing: border-box;
		transition: var(--fszs-transition);
	}

	.levelmang-table-li-tab-li > div > input:focus,
	.levelmang-table-ZK input:focus,
	.levelmang-table-YH input:focus {
		border-color: var(--fszs-primary);
		box-shadow: var(--fszs-focus);
		outline: none;
	}

	.billOperationRecord .statistic,
	.billOperationRecord .customerManagementPC-page,
	.billOperationRecord .billOperationRecord-page,
	.billOperationRecord .pulbic_pagesize,
	.billOperationRecord .systemCorporateAccount-dialog-btn,
	.billOperationRecord .salesPreferentialDig-btn {
		flex-wrap: wrap;
	}

	@media screen and (max-width: 1366px) {
		.billOperationRecord {
			padding: 14px;
		}

		.billOperationRecord > .pulbic_oparetionBlock:first-child {
			padding: 14px;
		}

		.billOperationRecord .customerManagementPC-table-btn {
			justify-content: flex-start;
		}

		.levelmang-table-KJ,
		.levelmang-table-ZK,
		.levelmang-table-YH {
			width: 180px;
		}
	}

.sales-invoice-page {
	position: relative;
	box-sizing: border-box;
	min-height: 100%;
	padding: 16px;
	background:
		radial-gradient(circle at 86% 4%, rgba(42, 122, 214, .15), transparent 27%),
		radial-gradient(circle at 6% 28%, rgba(28, 176, 136, .12), transparent 24%),
		linear-gradient(180deg, #edf5fb 0%, #f6fafc 46%, #f8fbfd 100%);
	--invoice-primary: #2476d8;
	--invoice-primary-dark: #1859aa;
	--invoice-accent: #1cae86;
	--invoice-text: #213547;
	--invoice-muted: #718399;
	--invoice-border: #d9e6f2;
	--invoice-soft: #f4f8fc;
	--invoice-shadow: 0 14px 34px rgba(32, 57, 86, .1);
	font-family: "Microsoft YaHei", sans-serif;
}

.sales-invoice-page .sales-invoice-filter-panel,
.sales-invoice-page .sales-invoice-table-card {
	box-sizing: border-box;
	border: 1px solid rgba(217, 230, 242, .95);
	border-radius: 18px;
	background: rgba(255, 255, 255, .96);
	box-shadow: var(--invoice-shadow);
}

.sales-invoice-page .sales-invoice-filter-panel {
	padding: 18px 20px;
	margin-bottom: 14px;
}

.sales-invoice-filter-head,
.sales-invoice-table-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.sales-invoice-filter-title,
.sales-invoice-table-title {
	position: relative;
	padding-left: 12px;
	color: var(--invoice-text);
	font-size: 18px;
	font-weight: 800;
	line-height: 1.35;
}

.sales-invoice-filter-title::before,
.sales-invoice-table-title::before {
	content: "";
	position: absolute;
	left: 0;
	top: 4px;
	width: 4px;
	height: 18px;
	border-radius: 8px;
	background: linear-gradient(180deg, var(--invoice-primary), var(--invoice-accent));
}

.sales-invoice-filter-subtitle,
.sales-invoice-table-subtitle {
	margin-top: 6px;
	color: var(--invoice-muted);
	font-size: 13px;
}

.sales-invoice-filter-count,
.sales-invoice-table-tag {
	flex: 0 0 auto;
	padding: 8px 14px;
	border: 1px solid rgba(36, 118, 216, .14);
	border-radius: 999px;
	background: linear-gradient(135deg, rgba(36, 118, 216, .1), rgba(28, 174, 134, .1));
	color: var(--invoice-primary-dark);
	font-size: 13px;
	font-weight: 700;
}

.sales-invoice-page .sales-invoice-filter-controls {
	display: flex;
	flex-wrap: wrap;
	align-items: center !important;
	gap: 12px;
	margin: 18px 0 0;
	padding: 14px;
	border: 1px solid rgba(217, 230, 242, .8);
	border-radius: 14px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.sales-invoice-page .sales-invoice-search {
	display: flex;
	align-items: center !important;
	gap: 10px;
	height: auto;
	margin: 0;
}

.sales-invoice-page .sales-invoice-search .public_lbSty {
	width: auto;
	min-width: 52px;
	color: var(--invoice-text);
	font-weight: 700;
}

.sales-invoice-page .sales-invoice-search > input {
	width: 300px;
	height: 40px;
	padding: 0 14px;
	border: 1px solid var(--invoice-border);
	border-radius: 10px;
	background: #ffffff;
	color: var(--invoice-text);
	font-size: 14px;
	transition: all .18s ease;
}

.sales-invoice-page .sales-invoice-search > input:focus {
	border-color: var(--invoice-primary);
	box-shadow: 0 0 0 3px rgba(36, 118, 216, .14);
	outline: none;
}

.sales-invoice-page .sales-invoice-query-btn {
	height: 40px;
	min-width: 96px;
	margin-left: 0 !important;
	padding: 0 20px;
	border: none;
	border-radius: 10px;
	background: linear-gradient(135deg, var(--invoice-primary), #35a1f4) !important;
	box-shadow: 0 9px 18px rgba(36, 118, 216, .22);
	font-weight: 700;
}

.sales-invoice-page .sales-invoice-query-btn:hover {
	transform: translateY(-1px);
	box-shadow: 0 12px 22px rgba(36, 118, 216, .28);
}

.sales-invoice-page .sales-invoice-table-card {
	padding: 18px 18px 0;
	overflow: hidden;
}

.sales-invoice-page .sales-invoice-table-head {
	margin-bottom: 16px;
	padding-bottom: 14px;
	border-bottom: 1px solid rgba(217, 230, 242, .75);
}

.sales-invoice-page >>> .sales-invoice-main-table {
	border-radius: 14px;
	overflow: hidden;
}

.sales-invoice-page >>> .sales-invoice-main-table::before {
	display: none;
}

.sales-invoice-page >>> .sales-invoice-main-table th {
	background: linear-gradient(180deg, #f4f9ff 0%, #eaf4ff 100%) !important;
}

.sales-invoice-page >>> .sales-invoice-main-table th .cell {
	color: #24384b;
	font-size: 14px;
	font-weight: 800;
	white-space: nowrap;
}

.sales-invoice-page >>> .sales-invoice-main-table td {
	padding: 10px 0;
	border-bottom: 1px solid rgba(225, 234, 244, .86);
}

.sales-invoice-page >>> .sales-invoice-main-table .el-table__row:hover > td {
	background: #f4f9ff !important;
}

.sales-invoice-page >>> .sales-invoice-main-table .cell {
	color: var(--invoice-text);
	font-size: 13px;
}

.sales-invoice-page >>> .sales-invoice-main-table .public_icon_width {
	min-width: 84px;
	height: 32px;
	padding: 0 14px;
	border: none;
	border-radius: 999px;
	font-weight: 700;
}

.sales-invoice-page >>> .sales-invoice-main-table .public_icon_qiyong {
	background: linear-gradient(135deg, #1cae86, #34c6a1) !important;
	color: #ffffff !important;
}

.sales-invoice-page >>> .sales-invoice-main-table .public_icon_xiugai {
	background: linear-gradient(135deg, #f0a13a, #f7bd62) !important;
	color: #ffffff !important;
}

.sales-invoice-page >>> .sales-invoice-main-table .el-table__body-wrapper {
	overflow-x: hidden;
}

.sales-invoice-page >>> .sales-invoice-main-table .el-table__header-wrapper,
.sales-invoice-page >>> .sales-invoice-main-table .el-table__body-wrapper {
	width: 100%;
}

.sales-invoice-page >>> .sales-invoice-main-table .el-table__body,
.sales-invoice-page >>> .sales-invoice-main-table .el-table__header {
	width: 100% !important;
}

.sales-invoice-page >>> .sales-invoice-main-table .public_icon_margin + .public_icon_margin {
	margin-left: 0;
	margin-top: 6px;
}

.sales-invoice-page .pulbic_pagesize {
	display: flex;
	justify-content: flex-end;
	padding: 14px 0 4px;
	margin-top: 10px;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog {
	width: 1080px !important;
	max-width: calc(100vw - 32px);
	border-radius: 20px;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog__header {
	position: relative;
	padding: 18px 24px;
	background:
		radial-gradient(circle at 94% 10%, rgba(28, 174, 134, .18), transparent 28%),
		linear-gradient(135deg, #eef7ff 0%, #f8fcff 100%);
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog__title {
	letter-spacing: .5px;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog__body {
	max-height: 72vh;
	padding: 18px 22px 20px;
	overflow-y: auto;
	background: linear-gradient(180deg, #fbfdff 0%, #ffffff 34%);
}

.sales-invoice-page .invoice-setting-dialog {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.sales-invoice-page .invoice-setting-banner {
	grid-column: 1 / -1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 18px;
	padding: 16px 18px;
	border: 1px solid rgba(36, 118, 216, .14);
	border-radius: 16px;
	background:
		radial-gradient(circle at 90% 20%, rgba(36, 118, 216, .16), transparent 26%),
		linear-gradient(135deg, #f2f8ff 0%, #f8fbff 100%);
}

.sales-invoice-page .invoice-setting-banner-title {
	color: var(--invoice-text);
	font-size: 18px;
	font-weight: 800;
	line-height: 1.4;
}

.sales-invoice-page .invoice-setting-banner-text {
	margin-top: 4px;
	color: var(--invoice-muted);
	font-size: 13px;
}

.sales-invoice-page .invoice-setting-banner-badge {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	border-radius: 16px;
	background: linear-gradient(135deg, var(--invoice-primary), var(--invoice-accent));
	box-shadow: 0 12px 22px rgba(36, 118, 216, .22);
	color: #ffffff;
	font-size: 22px;
	font-weight: 900;
}

.sales-invoice-page .invoice-setting-section-title {
	grid-column: 1 / -1;
	position: relative;
	margin-top: 2px;
	padding: 0 0 0 12px;
	color: var(--invoice-text);
	font-size: 15px;
	font-weight: 800;
	line-height: 28px;
}

.sales-invoice-page .invoice-setting-section-title::before {
	content: "";
	position: absolute;
	left: 0;
	top: 7px;
	width: 4px;
	height: 14px;
	border-radius: 6px;
	background: var(--invoice-accent);
}

.sales-invoice-page .invoice-setting-field {
	display: grid;
	grid-template-columns: 90px minmax(0, 1fr);
	align-items: center;
	min-height: 56px;
	padding: 12px;
	background: #ffffff;
}

/* 企业名称占满整行 */
.sales-invoice-page .invoice-setting-field--full {
	grid-column: 1 / -1 !important;
}

/* 是否开票、业务公司列宽一致 */
.sales-invoice-page .invoice-setting-field--narrow {
	grid-column: span 1;
}
.sales-invoice-page .invoice-setting-field--narrow .SCADL-input .el-select,
.sales-invoice-page .invoice-setting-field:not(.invoice-setting-field--full):not(.invoice-setting-field--narrow) .SCADL-input .el-select {
	width: 140px !important;
	max-width: 140px !important;
}

/* 客户开票比例：label 在左，input 在右 */
.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li {
	display: grid !important;
	grid-template-columns: 80px minmax(0, 1fr) !important;
	align-items: center !important;
	gap: 8px !important;
}
.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li .SCADL-text {
	margin-bottom: 0 !important;
	white-space: nowrap;
}

.sales-invoice-page .invoice-setting-field .SCADL-text,
.sales-invoice-page .invoice-setting-level-grid .SCADL-text {
	line-height: 20px;
	text-align: left;
	align-self: center;
}

.sales-invoice-page .invoice-setting-ratio-title {
	margin-top: 6px;
	grid-column: auto !important;
	font-size: 13px !important;
	font-weight: 600 !important;
	padding: 0 8px !important;
	display: flex;
	align-items: center;
	background: transparent !important;
	border: none !important;
	color: var(--fszs-primary) !important;
	min-height: unset !important;
}

.sales-invoice-page .invoice-setting-level-grid {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
	margin-top: 0;
}

.sales-invoice-page .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li {
	display: block;
	padding: 10px 12px;
	border-radius: 14px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
}

.sales-invoice-page .invoice-setting-level-grid .SCADL-text {
	margin-bottom: 8px;
	font-size: 13px;
}

.sales-invoice-page .invoice-setting-level-grid .SCADL-input .el-input,
.sales-invoice-page .invoice-setting-level-grid .SCADL-input .el-input__inner {
	width: 100%;
}

.sales-invoice-page .invoice-setting-actions {
	position: sticky;
	bottom: -20px;
	grid-column: 1 / -1;
	z-index: 3;
	justify-content: flex-end;
	margin-top: 4px;
	padding: 14px 0 0;
	background: linear-gradient(180deg, rgba(255, 255, 255, .86), #ffffff 46%);
}

.sales-invoice-page .invoice-setting-actions .el-button {
	min-width: 104px;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-select,
.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-input {
	width: 100%;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-input__inner {
	height: 38px !important;
	line-height: 38px !important;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap input[readonly],
.sales-invoice-page >>> .invoice-setting-dialog-wrap input:disabled {
	background: #eef5fb !important;
	color: #5c6f83 !important;
	cursor: not-allowed;
}

.sales-invoice-page >>> .public-dialog .el-dialog {
	border-radius: 18px;
	background: #ffffff;
	overflow: hidden;
	box-shadow: 0 18px 46px rgba(28, 49, 75, .18);
}

.sales-invoice-page >>> .public-dialog .el-dialog__header {
	padding: 18px 22px;
	background: linear-gradient(135deg, #eff7ff 0%, #f7fbff 100%);
	border-bottom: 1px solid rgba(217, 230, 242, .9);
}

.sales-invoice-page >>> .public-dialog .el-dialog__title {
	color: var(--invoice-text);
	font-size: 18px;
	font-weight: 800;
}

.sales-invoice-page >>> .public-dialog .el-dialog__body {
	padding: 20px 22px 22px;
}

.sales-invoice-page .systemCorporateAccount-dialog {
	gap: 14px 16px;
	padding: 0;
}

.sales-invoice-page .systemCorporateAccount-dialog-li,
.sales-invoice-page .level-systemCorporateAccount-dialog-li {
	border-color: rgba(217, 230, 242, .92);
	border-radius: 12px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.sales-invoice-page .levelBox {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
	margin-top: 0;
}

.sales-invoice-page .level-systemCorporateAccount-dialog-li {
	margin-bottom: 0;
}

.sales-invoice-page .SCADL-text {
	color: var(--invoice-muted);
	font-size: 14px;
	font-weight: 700;
}

.sales-invoice-page .SCADL-text span {
	margin-right: 2px;
	color: #e85b55;
}

.sales-invoice-page .systemCorporateAccount-dialog-btn .el-button {
	min-width: 96px;
	height: 38px;
	padding: 0 22px;
	border: none;
	border-radius: 10px;
	font-weight: 700;
}

.sales-invoice-page .systemCorporateAccount-dialog-btn .el-button--primary {
	background: linear-gradient(135deg, var(--invoice-primary), #35a1f4);
}

.sales-invoice-page .systemCorporateAccount-dialog-btn .el-button--warning {
	background: linear-gradient(135deg, #f0a13a, #f7bd62);
}

.sales-invoice-page >>> .el-input-group__append {
	border-color: var(--invoice-border);
	border-radius: 0 9px 9px 0;
	background: #eef5fb;
	color: var(--invoice-muted);
	font-weight: 700;
}

.sales-invoice-page >>> .el-pagination.is-background .el-pager li:not(.disabled).active,
.sales-invoice-page >>> .el-pagination .el-pager li.active {
	background: var(--invoice-primary);
	color: #ffffff;
}

@media screen and (max-width: 1366px) {
	.sales-invoice-page {
		padding: 12px;
	}

	.sales-invoice-page .sales-invoice-filter-panel,
	.sales-invoice-page .sales-invoice-table-card {
		border-radius: 14px;
	}

	.sales-invoice-page .levelBox {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media screen and (max-width: 768px) {
	.sales-invoice-filter-head,
	.sales-invoice-table-head {
		align-items: flex-start;
		flex-direction: column;
	}

	.sales-invoice-page .sales-invoice-search,
	.sales-invoice-page .sales-invoice-search > input,
	.sales-invoice-page .sales-invoice-query-btn {
		width: 100%;
	}

	.sales-invoice-page .levelBox,
	.sales-invoice-page .systemCorporateAccount-dialog {
		grid-template-columns: 1fr;
	}
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog {
	width: 1080px !important;
	max-width: calc(100vw - 32px);
	border-radius: 20px;
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog__header {
	padding: 18px 24px;
	background:
		radial-gradient(circle at 94% 10%, rgba(28, 174, 134, .18), transparent 28%),
		linear-gradient(135deg, #eef7ff 0%, #f8fcff 100%);
}

.sales-invoice-page >>> .invoice-setting-dialog-wrap .el-dialog__body {
	max-height: 72vh;
	padding: 18px 22px 20px;
	overflow-y: auto;
	background: linear-gradient(180deg, #fbfdff 0%, #ffffff 34%);
}

.sales-invoice-page .invoice-setting-dialog {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-banner,
.sales-invoice-page .invoice-setting-dialog .invoice-setting-section-title,
.sales-invoice-page .invoice-setting-dialog .invoice-setting-level-grid,
.sales-invoice-page .invoice-setting-dialog .invoice-setting-actions {
	grid-column: 1 / -1;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-level-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 16px 24px;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-field {
	display: flex !important;
	flex-direction: row !important;
	align-items: center !important;
	gap: 8px !important;
	padding: 12px;
	background: #ffffff;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-field .SCADL-text {
	flex-shrink: 0 !important;
	width: 70px !important;
	text-align: right !important;
	white-space: nowrap !important;
	line-height: 1.4 !important;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-field .SCADL-input {
	flex: 1 !important;
	min-width: 0 !important;
}

.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li {
	display: flex !important;
	flex-direction: row !important;
	align-items: center !important;
	padding: 14px 12px;
	border-radius: 14px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	gap: 8px;
}

.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li .SCADL-text {
	flex-shrink: 0;
	width: 68px;
	text-align: right;
	white-space: nowrap;
	font-size: 13px;
	margin-bottom: 0 !important;
	line-height: 1.4;
}

.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li .SCADL-input {
	flex: none;
	width: 80px;
}

.sales-invoice-page .invoice-setting-dialog .level-systemCorporateAccount-dialog-li .SCADL-input .el-input {
	width: 80px !important;
}

.sales-invoice-page .invoice-setting-dialog .invoice-setting-actions {
	position: sticky;
	bottom: -20px;
	z-index: 3;
	justify-content: flex-end;
	margin-top: 4px;
	padding: 14px 0 0;
	background: linear-gradient(180deg, rgba(255, 255, 255, .86), #ffffff 46%);
}

@media screen and (max-width: 1366px) {
	.sales-invoice-page .invoice-setting-dialog .invoice-setting-level-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media screen and (max-width: 768px) {
	.sales-invoice-page .invoice-setting-dialog {
		grid-template-columns: 1fr;
	}

	.sales-invoice-page .invoice-setting-dialog .invoice-setting-level-grid {
		grid-template-columns: 1fr;
	}
}
</style>
<style>
/* 客户开票比例标题不独占一行 */
.invoice-setting-dialog .invoice-setting-ratio-title {
	grid-column: auto !important;
	font-size: 13px !important;
	padding: 0 8px !important;
	min-height: unset !important;
	margin-top: 4px !important;
}
/* 是否开票和业务公司宽度一致 */
.invoice-setting-dialog .invoice-setting-field .SCADL-input .el-select {
	width: 140px !important;
	max-width: 140px !important;
}
/* 是否开票和业务公司强制在同一行 */
.invoice-setting-dialog .invoice-setting-field--narrow,
.invoice-setting-dialog .invoice-setting-field:not(.invoice-setting-field--full) {
	grid-column: span 1 !important;
}
/* 是否开票、业务公司内部 label+select 左右布局 */
.invoice-setting-dialog .invoice-setting-field {
	display: flex !important;
	flex-direction: row !important;
	align-items: center !important;
	gap: 8px !important;
}
.invoice-setting-dialog .invoice-setting-field .SCADL-text {
	flex-shrink: 0 !important;
	width: 70px !important;
	text-align: right !important;
	white-space: nowrap !important;
}
.invoice-setting-dialog .invoice-setting-field .SCADL-input {
	flex: 1 !important;
	min-width: 0 !important;
}
/* 企业名称占满整行，在 invoice-setting-dialog 的 grid 里 */
.invoice-setting-dialog .invoice-setting-field--full {
	grid-column: 1 / -1 !important;
}
.invoice-setting-dialog .invoice-setting-field--full .SCADL-input {
	width: 100%;
}
.invoice-setting-dialog .invoice-setting-field--full .SCADL-input input {
	width: 100% !important;
	box-sizing: border-box !important;
}
.invoice-setting-dialog .invoice-setting-field--narrow .SCADL-input .el-select {
	width: 140px !important;
	max-width: 140px !important;
}
/* 客户开票比例卡片：左右布局，label 紧凑 */
.invoice-setting-dialog .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li {
	display: flex !important;
	flex-direction: row !important;
	align-items: center !important;
	gap: 8px !important;
	/* margin-bottom: 0 !important; */
	padding: 8px 10px !important;
}
.invoice-setting-dialog .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li .SCADL-text {
	white-space: nowrap;
	font-size: 13px;
	flex-shrink: 0;
	width: 68px;
	text-align: right;
}
.invoice-setting-dialog .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li .SCADL-input {
	flex: 1;
	min-width: 0;
}
.invoice-setting-dialog .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li .SCADL-input .el-input {
	width: 100% !important;
}
.invoice-setting-dialog .invoice-setting-level-grid .level-systemCorporateAccount-dialog-li .SCADL-input .el-input__inner {
	padding-right: 8px !important;
}
.sales-invoice-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-invoice-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-invoice-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-invoice-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-invoice-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
